import axios from 'axios';
import { message } from 'antd';
import store from '../store';

// axios.defaults.baseURL = 'http://192.168.2.2:81/';
// axios.defaults.baseURL = 'https://www.kzmooc.com/front/api/'

// if (process.env.NODE_ENV === 'development') {
//   axios.defaults.baseURL = '/front/api/'
// } else {
//   axios.defaults.baseURL = 'https://www.kzmooc.com/front/api/'
// }
axios.defaults.baseURL = '/front/api/'
axios.defaults.headers.common['Accept'] = 'application/vnd.kzmooc.v1+json';
axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';

let refreshing = false;
async function refreshToken() {
  const loginInfo = store.getState().loginInfo;

  if (loginInfo.access_token !== '') {
    const now = Date.now();
    const dis = (now - loginInfo.record_time) / 1000;

    if (
      loginInfo.access_token !== ''    &&
      loginInfo.expires_in - dis <= 30  &&
      refreshing === false
    ) {
      refreshing = true;
      const { data } = await axios.get('user/refresh-token');
      store.dispatch.loginInfo.saveLoginInfo(data.data);
      axios.defaults.headers.common['Authorization'] = `Bearer ${data.data.access_token}`;
      refreshing = false;
      return data.data.access_token
    }
  }
}

// Add a request interceptor
axios.interceptors.request.use(async function (config) {
  const token = await refreshToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  // if (response.headers.token !== undefined) {
  //   store.dispatch.user.updateToken(response.headers.token); 
  // }
  return response;
}, function (error) {
  if (
    error.response !== undefined &&
    error.response.status === 401
  ) {
    message.error('登陆过期, 请重新登录!');
    store.dispatch.loginInfo.clearLoginInfo();
    store.dispatch.userInfo.clearUserInfo();
    window.location.hash = '/auth/login';
  }
  return Promise.reject(error);
});
